import Vue from 'vue'
import VueI18n from 'vue-i18n'
import mainI18n from '../../i18n'

Vue.use(VueI18n)

// Load IB-specific messages
function loadIBMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

// Merge IB messages with main app messages
function mergeMessages() {
  const ibMessages = loadIBMessages()
  const mainMessages = mainI18n.messages
  const mergedMessages = {}

  const allLocales = new Set([
    ...Object.keys(ibMessages),
    ...Object.keys(mainMessages)
  ])

  allLocales.forEach(locale => {
    mergedMessages[locale] = {
      ...(mainMessages[locale] || {}),
      ...(ibMessages[locale] || {})
    }
  })

  return mergedMessages
}

const ibI18n = new VueI18n({
  locale: mainI18n.locale,
  fallbackLocale: mainI18n.fallbackLocale,
  messages: mergeMessages(),
  silentTranslationWarn: true
})

export const setLocale = (locale) => {
  ibI18n.locale = locale
  mainI18n.locale = locale
  localStorage.setItem('user-locale', locale)
  document.querySelector('html').setAttribute('lang', locale)
}

export const getLocale = () => ibI18n.locale

export const getAvailableLocales = () => {
  return [
    { code: 'en', name: 'English', flag: 'US' },
    { code: 'es', name: 'Espanol', flag: 'ES' },
    { code: 'ja', name: 'Japanese', flag: 'JP' },
    { code: 'ko', name: 'Korean', flag: 'KR' },
    { code: 'pt', name: 'Portugues', flag: 'PT' },
    { code: 'th', name: 'Thai', flag: 'TH' },
    { code: 'vi', name: 'Tieng Viet', flag: 'VN' },
    { code: 'zh', name: 'Chinese', flag: 'CN' },
    { code: 'zh-Hant', name: 'Traditional Chinese', flag: 'TW' }
  ]
}

export default ibI18n
